import React, { useEffect, useRef, useState } from 'react';
import { MoreHorizontal, Bookmark, Flag, Pencil, Trash2 } from 'lucide-react';

const PostActionsMenu = ({
  isOwner,
  isSaved,
  onToggleSave,
  onEdit,
  onReport,
  onDelete
}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  const handleAction = (callback) => {
    setOpen(false);
    callback?.();
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
        onClick={() => setOpen((value) => !value)}
        aria-label="Open post actions"
      >
        <MoreHorizontal size={18} />
      </button>

      {open && (
        <div className="absolute right-0 top-full z-20 mt-2 w-48 rounded-xl border border-gray-200 bg-white py-1 shadow-lg">
          {isOwner && (
            <button
              type="button"
              className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
              onClick={() => handleAction(onEdit)}
            >
              <Pencil size={16} />
              Edit post
            </button>
          )}

          <button
            type="button"
            className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
            onClick={() => handleAction(onToggleSave)}
          >
            <Bookmark size={16} className={isSaved ? 'fill-current' : ''} />
            {isSaved ? 'Unsave post' : 'Save post'}
          </button>

          {!isOwner && (
            <button
              type="button"
              className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
              onClick={() => handleAction(onReport)}
            >
              <Flag size={16} />
              Report post
            </button>
          )}

          {isOwner && (
            <button
              type="button"
              className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50"
              onClick={() => handleAction(onDelete)}
            >
              <Trash2 size={16} />
              Delete post
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PostActionsMenu;
